var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.is_show_navtar)?_c('navtar'):_vm._e(),_c('div',{staticClass:"appCon",class:{'appcon-content': _vm.is_show_navtar}},[_c('router-view')],1),_c('div',{attrs:{"id":"printArea"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }